import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CooperationEventDialogComponent } from './cooperation-event-dialog/cooperation-event-dialog.component';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { TextboxDialogComponent } from './textbox-dialog/textbox-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePeriodDialogComponent} from './date-period-dialog/date-period-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {MatRippleModule} from '@angular/material/core';
import { EditArtistDialogComponent } from './edit-artist-dialog/edit-artist-dialog.component';
import { EditCustomerDialogComponent } from './edit-customer-dialog/edit-customer-dialog.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CooperationSelectionDialogComponent } from './cooperation-selection-dialog/cooperation-selection-dialog.component';
import {MatSelectModule} from "@angular/material/select";
import { PlatformConnectionDialogComponent } from './platform-connection-dialog/platform-connection-dialog.component';
import { ProfileInsightDialogComponent } from './profile-insight-dialog/profile-insight-dialog.component';
import { DistributionDialogComponent } from './distribution-dialog/distribution-dialog.component';
import {CooperationDialogComponent} from "./cooperation-dialog/cooperation-dialog.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {EventModule} from "../parts/event/event.module";
import {MatChipsModule} from "@angular/material/chips";
import { ContactWizardDialogComponent } from './contact-wizard-dialog/contact-wizard-dialog.component';
import {CurrencyInputModule} from "../parts/currency-input/currency-input.module";
import {StatefulButtonModule} from "../parts/stateful-button/stateful-button.module";
import { AcquisitionFormDialogComponent } from './acquisition-form-dialog/acquisition-form-dialog.component';
import { BillingCycleDialogComponent } from './billing-cycle-dialog/billing-cycle-dialog.component';
import { AddPaymentDialogComponent } from './add-payment-dialog/add-payment-dialog.component';
import { CreateSettlementDialogComponent } from './create-settlement-dialog/create-settlement-dialog.component';
import { CreateContactDialogComponent } from './create-contact-dialog/create-contact-dialog.component';
import { BrandDialogComponent } from './brand-dialog/brand-dialog.component';
import {MediaModule} from "../parts/media/media.module";
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { CreateInvoiceDialogComponent } from './create-invoice-dialog/create-invoice-dialog.component';
import { MergeCustomerDialogComponent } from './merge-customer-dialog/merge-customer-dialog.component';
import {MatMenuModule} from "@angular/material/menu";
import { RevenueGoalDialogComponent } from './revenue-goal-dialog/revenue-goal-dialog.component';
import { CreateCreditDialogComponent } from './create-credit-dialog/create-credit-dialog.component';
import {MessagingAccountDialogComponent} from "./messaging-account-dialog/messaging-account-dialog.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {NgxCurrencyDirective} from "ngx-currency";
import {MatLegacyChipsModule} from "@angular/material/legacy-chips";
import { EntitySelectDialogComponent } from './entity-select-dialog/entity-select-dialog.component';
import {DirectivesModule} from "../directives/directives.module";
import {LottieComponent} from "ngx-lottie";
import {CdkDrag, CdkDragHandle} from "@angular/cdk/drag-drop";
import { EventTypeDialogComponent } from './event-type-dialog/event-type-dialog.component';



@NgModule({
    declarations: [CooperationEventDialogComponent, DatePeriodDialogComponent, NoteDialogComponent, TextboxDialogComponent,
        ConfirmDialogComponent, EditArtistDialogComponent, EditCustomerDialogComponent, CooperationSelectionDialogComponent,
        PlatformConnectionDialogComponent, ProfileInsightDialogComponent, DistributionDialogComponent, CooperationDialogComponent,
        MessagingAccountDialogComponent,
        ContactWizardDialogComponent, AcquisitionFormDialogComponent, BillingCycleDialogComponent, AddPaymentDialogComponent, CreateSettlementDialogComponent, CreateContactDialogComponent, BrandDialogComponent, FeedbackDialogComponent, CreateInvoiceDialogComponent, MergeCustomerDialogComponent, CreateCreditDialogComponent, RevenueGoalDialogComponent, EntitySelectDialogComponent, EventTypeDialogComponent
    ],
    exports: [
        NoteDialogComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        FormsModule,
        MatIconModule,
        NgxMatDatetimePickerModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatRippleModule,
        MatTabsModule,
        MatCheckboxModule,
        MatSelectModule,
        MatAutocompleteModule,
        EventModule,
        MatChipsModule,
        CurrencyInputModule,
        StatefulButtonModule,
        MediaModule,
        MatMenuModule,
        MatExpansionModule,
        NgxCurrencyDirective,
        DirectivesModule,
        LottieComponent,
        CdkDrag,
        CdkDragHandle
    ]
})
export class DialogsModule { }
